import { Button, ButtonGroup, Card, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { dataCuotasPadres, toMakeLinkCuota } from "data/apiConection.js/dataCuotasPadres";
import React from "react";
import CardMes from "./CardMes";
import CardTicket from "../cards-tickets/CardTicket";
import CardProfile from "./Card-Profile";
import CardWeb from "./CardWeb";
import { FaPrint } from "react-icons/fa";
import { dataAlumno } from "data/apiConection.js/dataAlumnos";
import { addCuotaByAlumno } from "data/apiConection.js/dataCuotas";
import PagosTable from "components/dashboards/crm/recent-leads/PagosTable";
const CardMeses = ({ father }) => {
  const [cuotas, setCuotas] = useState([]);
  const [ flagMakeLink , setFlagMakeLink ] = useState(false);
  const [ cuotaId , setCuotaId ] = useState('');
  const [ urlFlag , setUrlFlag ] = useState(false);
  const [ url , setUrl ] = useState('');
  const [ alumno , setAlumno ] = useState({});
  const [ cuotasPrint , setCuotasPrint ] = useState([]);
  const [ isTable , setIsTable ] = useState(false);
  const [ isCard , setIsCard ] = useState(false);
  const printRef = useRef();
  console.log(father);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (father?.id) {
          const c = await dataCuotasPadres(father.id);
          setCuotas(c);
          console.log('Numero de meses --> ',c.length);
        }
      } catch (error) {
        console.error("Error fetching cuotas:", error);
      }
    };
    fetchData();
  }, [father?.id, flagMakeLink , cuotaId]);
  useEffect(() => {
    const fetchAlumno = async () => {
       if (!father?.id) return;
      try {
        const ciclo = '2025';
        const a = await dataAlumno(father.id,ciclo);
        setAlumno(a);
      } catch (error) {
        console.error("Error fetching alumno :", error);
      }
    }
    fetchAlumno();
  },[father.id]);
const handleButtonPayed = async (idAlumno, mes, cuota) => {
    try {
        if (cuota.status === "pending") {
            const url = `https://servicios.paypertic.com/formularios/v2/pagos/${cuota.id_pagos_tic}`;
            setUrl(url);
            setUrlFlag(!urlFlag);
            setCuotaId('');
            flagMakeLink && setFlagMakeLink(!flagMakeLink);
        } else if (cuota.status === 'pagado') {
            setCuotaId(cuota.id);
            setFlagMakeLink(!flagMakeLink);
        } else {
            const responseTic = await toMakeLinkCuota(idAlumno, mes);
            const url = responseTic.id?`https://servicios.paypertic.com/formularios/v2/pagos/${responseTic.id}`:'';
            console.log(responseTic);
             setUrl(url);
            setUrlFlag(!urlFlag);
            setCuotaId('');
            flagMakeLink && setFlagMakeLink(!flagMakeLink);
        }
    } catch (error) {
        console.error("Error al generar link de pago:", error);
    }
};
const handleBouttonToPrintAll = () => {
  if (!cuotas.length) return;
  const printContents = cuotasPrint.length?cuotasPrint.map(cuota => {
    if( cuota.status === 'pagado'){
     return `<div style="font-family: 'Times New Roman', serif; max-width: 600px; margin: 0 auto; padding: 20px;">

  <div style="text-align: right; font-size: 12px;">
    <span>${new Date().toLocaleDateString()} - ${new Date().toLocaleTimeString()}</span><br>
    <strong>Comprobante de Cuota Mensual</strong>
  </div>

  <h4 style="margin-top: 40px; margin-bottom: 5px;">Asociación de cultura Saint John's</h4>
  <p style="margin: 0;">asociacionsj@gmail.com</p>

  <p><strong>Fecha:</strong> ${cuota.updated_at && cuota.updated_at.split('T')[0] + ' - ' + cuota.updated_at.split('T')[1].split('Z')[0]}</p>
  <p><strong>Estado:</strong> ${cuota.status}</p>
  <p><strong>Nombre:</strong> ${alumno.firstName + ' ' + alumno.lastName}</p>

  <hr style="border: 1px solid #aaa;">

  <p><strong>Identificador:</strong> ${cuota.id}</p>
  <p><strong>Concepto:</strong> Cuota Mensual</p>
  <p><strong>Importe:</strong> ARS ${Number(cuota.monto).toFixed(2)}</p>

  <hr style="border: 1px solid #aaa;">

  <p><strong>Total: ARS ${Number(cuota.monto).toFixed(2)}</strong></p>
  <p><strong>Medio de pago:</strong> ${cuota.metodo || "N/A"}</p>

</div>
`;
    } else {
      return
    }

  }).join(''):alert("Debes Selecccionar los meses que deseas imprimir!");

  const win = window.open('', '', 'height=800,width=600');
  win.document.write('<html><head><title>Cuotas</title></head><body>');
  win.document.write(printContents);
  win.document.write('</body></html>');
  win.document.close();
  win.focus();
  win.print();
  win.close();
};
const handleButtonCuotaEfectivo = async (cuota) => {
  try {
    await addCuotaByAlumno(cuota);
  } catch (error) {
    console.error("Error adding cuota :", error);
  }
}
const toGetMonthInscription = alumno => alumno.created_at?parseInt(alumno.created_at.split('-')[1].split('-')[0])-3:0;
      
const handleButtonTableOrCards = (isTableFlag = false , isCardFlag = false ) => {
  isTableFlag && setIsTable(!isTable);
  isCardFlag && setIsCard(!isCard);
}

  return (
    <Card className="shadow">
      <Card.Header className="text-center fw-bold">Meses de pago
      </Card.Header>
      <Card.Body>
         <Row>
            <Col>
              {alumno && <CardProfile father = {father} />}
            </Col>
        </Row>
        <Row>
            <Col>
              <ButtonGroup>
                <Button onClick={() => handleButtonTableOrCards(true, isCard)}>Tabla</Button>
                <Button onClick={() => handleButtonTableOrCards(isTable, true)}>Tarjetas</Button>
              </ButtonGroup>
            </Col>  
        </Row>
        {
          isCard &&        
          <div><Row> <Col className="text-end m-3"><Button onClick={handleBouttonToPrintAll}>Imprimir Todo<FaPrint className="m-2" /></Button></Col></Row>
         <div ref={printRef}>
        <Row   xs={1} sm={2} md={3} lg={4} className="g-3">
              {cuotas && cuotas.map((cuota, index) => (
              toGetMonthInscription(alumno) <= index &&
                <Col key={index}>
                  <CardMes
                    handleButtonCuotaEfectivo = {handleButtonCuotaEfectivo} 
                    setCuotasPrint={setCuotasPrint}  
                    cuota={cuota} handleButtonPayed={handleButtonPayed} 
                    father={father} 
                  />
                </Col>
              ))}
        </Row>
        </div>
         </div>}
         {
          isTable && <div>
             <Row> <Col className="text-end m-3"><Button onClick={handleBouttonToPrintAll}>Imprimir Todo<FaPrint className="m-2" /></Button></Col></Row>
             <Row><Col><PagosTable setCuotaId = {setCuotaId} cuotas = {cuotas} /></Col></Row>
          </div>
           
        }

          <Row>
          <Col>{cuotaId && (
              <CardTicket alumnoId={father.id} cuotaId={cuotaId} />
          )}</Col>
        </Row>
        <Row>
          <Col>
              {urlFlag && (
                <CardWeb url = {url} />
              )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

CardMeses.propTypes = {
  father: PropTypes.object.isRequired,
};

export default CardMeses;

